import { Controller } from '@hotwired/stimulus';
import Freezeframe from 'freezeframe';

function isGif(src) {
  if (!src) return false;
  const ext = src.split('.').pop().toLowerCase().split(/[?#]/)[0];
  return ext === 'gif';
}

const OPTIONS = { trigger: false, overlay: true, responsive: true };

export default class extends Controller {
  connect() {
    this.processedImages = new WeakSet();
    this.addGIFControl(this.element);
    this.observeChange();
  }

  disconnect() {
    this.observer.disconnect();
  }

  observeChange() {
    var element = this.element;
    var callback = (_mutationsList, _observer) => {
      this.addGIFControl(element);
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  // This action is triggered from the global wrapper where gif-controls is set.
  // It is intended to be tied to keyboard controls (keydown.enter / keydown.space)
  toggleGif(event) {
    if (event.target?.ff) {
      event.target.ff.toggle();
      event.preventDefault();
    } // else let event bubble
  }

  attachGifControls(event) {
    this.addGIFControl(event.target);
  }

  // Adds Freezeframe to any nested img tags (querySelectorAll)
  addGIFControl(target) {
    if (typeof target.getElementsByTagName !== 'function') return;

    const imgs = Array.from(target.getElementsByTagName('img'));
    imgs.forEach((img) => {
      if (this.processedImages.has(img)) return;
      // Skip any img tag inside a hidden element. Mainly for tutorial steps.
      if (img.closest('.hidden')) return;
      // Skip GIFs inside image-zoom containers — they get <a> wrapping instead
      if (img.closest('[data-controller~="image-zoom"]')) return;
      if (!isGif(img.src)) return;
      if (!img.dataset.ff) {
        this.processedImages.add(img);
        this.initFreezeframe(img);
      }
    });
  }

  // Inits the freezeframe if ready, otherwise defers until loaded
  initFreezeframe(img) {
    if (img.complete && img.naturalWidth > 0) {
      this.createFreezeframe(img);
    } else {
      img.addEventListener('load', () => this.createFreezeframe(img), { once: true });
      img.addEventListener(
        'error',
        () => {
          console.error('[GIF Controls] Skipping broken image:', img.src);
        },
        { once: true }
      );
    }
  }

  createFreezeframe(img) {
    try {
      const ff = new Freezeframe(img, OPTIONS);
      img.ff = ff;
      img.dataset.ff = 'true';
      // Add keyboard accessibility by making img tabbable
      img.setAttribute('tabindex', '0');
    } catch (error) {
      console.error('[GIF Controls] Failed to initialize:', error.message);
    }
  }
}
